import styled from 'styled-components';

export const ErrorMessageText = styled.p`
  margin-left: 0;
  font-size: 14px;
  color: ${(props) => props.theme.colors.complementary.red};
`;
